<template>
  <router-view></router-view>
</template>


<script>
import store from "./store";
export default {
  name: "app",
  created: function() {
  	// console.log("this in app :::", this.$http.interceptors);
    this.$http.interceptors.response.use(undefined, function(err) {
      return new Promise(async (resolve, reject) => {
        if(err.response){
          if (err.response.status === 401) {
          console.log("NO AUTORIZADO, REDIRECT");
          await store.dispatch("logout").then(() => {
            window.location.replace("/#/login");
          });
        }
        }
        
        throw err;
      });
    });
  }
};
</script>



<style lang="scss">
// CoreUI Icons Set
@import "~@coreui/icons/css/free.css";
/* Import Font Awesome Icons Set */
$fa-font-path: "~font-awesome/fonts/";
@import "~font-awesome/scss/font-awesome.scss";
/* Import Simple Line Icons Set */
$simple-line-font-path: "~simple-line-icons/fonts/";
@import "~simple-line-icons/scss/simple-line-icons.scss";
/* Import Flag Icons Set */
@import "~flag-icon-css/css/flag-icon.min.css";
/* Import Bootstrap Vue Styles */
@import "~bootstrap-vue/dist/bootstrap-vue.css";
// Import Main styles for this application
@import "assets/scss/style";

</style>